<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Multiselect from 'vue-multiselect'

export default {

    page: {
        title: 'Новая позиций',
        meta: [{ name: 'description', content: appConfig.description }],
    },

    components: { Layout, PageHeader, Multiselect },

    data() {
        return {
            title: 'Новая позиций',
            items: [],
            item_uuid: '',
            trackBy: 'id',

            name: null,
            buy_cost: null,
            comments: null,
            article_number: null,
            code: null,

            brand: null,
            brands_options: [],
            initBrands: [],

            unit: null,
            units_options: [],
            initUnits: [],

            product_category: null,
            products_categories_options: [],
            initProductsCategories: [],
        }
    },

    watch: {
        initBrands: {
            immediate: true,
            handler(values) {
                this.brand = this.brands_options.filter(x => values.includes(x[this.trackBy]));
                this.brand = this.brand[0];
            }
        },
        initUnits: {
            immediate: true,
            handler(values) {
                this.unit = this.unitss_options.filter(x => values.includes(x[this.trackBy]));
                this.unit = this.unit[0];
            }
        },
        initProductsCategories: {
            immediate: true,
            handler(values) {
                this.product_category = this.products_categories_options.filter(x => values.includes(x[this.trackBy]));
                this.product_category = this.product_category[0];
            }
        },
    },

    computed: {
        brands_array_data(){
            return this.$store.getters['brands/GET_BRANDS_ARRAY_DATA'];
        },
        units_array_data(){
            return this.$store.getters['units/GET_UNITS_ARRAY_DATA'];
        },
        products_categories_array_data(){
            return this.$store.getters['productsCategories/GET_PRODUCTS_CATEGORIES_ARRAY_DATA'];
        },
        item(){
            return this.$store.getters['products/GET_PRODUCTS_ITEM'];
        },
        session_user_item(){
            let session = this.$store.getters['sessions/GET_SESSIONS_ITEM'];
            return session.user ? session.user : null;
        },
    },

    async mounted() {

        this.item_uuid = this.$route.params.uuid ? this.$route.params.uuid : '';

        await this.$store.dispatch('products/FETCH_PRODUCTS_LIST', {});
        this.product_options = this.product_array_data;

        await this.$store.dispatch('brands/FETCH_BRANDS_LIST', {});
        this.brands_options = this.brands_array_data;

        await this.$store.dispatch('units/FETCH_UNITS_LIST', {});
        this.units_options = this.units_array_data;

        await this.$store.dispatch('productsCategories/FETCH_PRODUCTS_CATEGORIES_LIST', {});
        this.products_categories_options = this.products_categories_array_data;

        if(this.item_uuid !== ''){

            this.title = 'Редактирование позиции';
            document.title = 'Редактирование позиции' + ' | ' + appConfig.title;

            await this.$store.dispatch('products/FETCH_PRODUCTS_ITEM', {'uuid': this.item_uuid});

            this.name = this.item.name ? this.item.name : null;
            this.article_number = this.item.article_number ? this.item.article_number : null;
            this.code = this.item.code ? this.item.code : null;

            this.brand = this.item.brand_id ? this.item.brand_id : null;
            if (this.brand !== null) {
                this.initBrands = [this.brand];
            }

            this.unit = this.item.unit_id ? this.item.unit_id : null;
            if (this.unit !== null) {
                this.initUnits = [this.unit];
            }

            this.product_category = this.item.product_category_id ? this.item.product_category_id : null;
            if (this.product_category !== null) {
                this.initProductsCategories = [this.product_category];
            }

            this.buy_cost = this.item.buy_cost ? this.item.buy_cost : null;
            this.comments = this.item.comments ? this.item.comments : null;
        }
    },

    methods: {

        async saveItem(){

            let data_send = {
                'name': this.name,
                'article_number': this.article_number,
                'code': this.code,
                'brand_id': this.brand && this.brand.id ? this.brand.id : null,
                'unit_id': this.unit && this.unit.id ? this.unit.id : null,
                'product_category_id': this.product_category && this.product_category.id ? this.product_category.id : null,
                'buy_cost': this.buy_cost,
                'comments': this.comments
            };

            let result = '';

            if(this.item_uuid === ''){
                result = await this.$store.dispatch('products/FETCH_PRODUCTS_CREATE', data_send);
            } else {
                data_send.uuid = this.item_uuid;
                result = await this.$store.dispatch('products/FETCH_PRODUCTS_UPDATE', data_send);
            }

            if(result === false){
                alert('Возникла ошибка');
            } else {
                this.$router.push({ name: 'Products'});
            }
        }
    },
}
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <b-form
            class="form-horizontal"
            @submit.prevent="saveItem"
        >
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col">

                                <b-form-group
                                    label="Название"
                                    label-for="name"
                                >
                                    <b-form-input
                                        id="name"
                                        v-model="name"
                                        placeholder=""
                                    ></b-form-input>
                                </b-form-group>

                                <b-form-group
                                    label="Артикул"
                                    label-for="article_number"
                                >
                                    <b-form-input
                                        id="article_number"
                                        v-model="article_number"
                                        placeholder=""
                                    ></b-form-input>
                                </b-form-group>

                                <b-form-group
                                    label="Код"
                                    label-for="code"
                                >
                                    <b-form-input
                                        id="code"
                                        v-model="code"
                                        placeholder=""
                                    ></b-form-input>
                                </b-form-group>

                                <b-form-group
                                    label="Бренд"
                                    label-for="brand"
                                >
                                    <multiselect
                                        id="brand"
                                        v-model="brand"
                                        :options="brands_options"
                                        placeholder="Выберите из списка"
                                        selectLabel="Нажмите, чтобы выбрать"
                                        deselectLabel="Нажмите, снять выделение"
                                        label="name"
                                        :track-by="trackBy"
                                    ></multiselect>
                                </b-form-group>

                                <b-form-group
                                    label="Категория"
                                    label-for="product_category"
                                >
                                    <multiselect
                                        id="product_category"
                                        v-model="product_category"
                                        :options="products_categories_options"
                                        placeholder="Выберите из списка"
                                        selectLabel="Нажмите, чтобы выбрать"
                                        deselectLabel="Нажмите, снять выделение"
                                        label="name"
                                        :track-by="trackBy"
                                    ></multiselect>
                                </b-form-group>

                                <b-form-group
                                    label="Единицы измерения"
                                    label-for="unit"
                                >
                                    <multiselect
                                        id="unit"
                                        v-model="unit"
                                        :options="units_options"
                                        placeholder="Выберите из списка"
                                        selectLabel="Нажмите, чтобы выбрать"
                                        deselectLabel="Нажмите, снять выделение"
                                        label="name"
                                        :track-by="trackBy"
                                    ></multiselect>
                                </b-form-group>

                                <b-form-group
                                    label="Себестоимость"
                                    label-for="buy_cost"
                                >
                                    <b-form-input
                                        id="buy_cost"
                                        v-model="buy_cost"
                                        placeholder=""
                                    ></b-form-input>
                                </b-form-group>

                                <b-form-group
                                    label="Комментари"
                                    label-for="comments"
                                >
                                    <b-form-input
                                        id="comments"
                                        v-model="comments"
                                        placeholder=""
                                    ></b-form-input>
                                </b-form-group>

                            </div>
                        </div>
                    </div>
                    <hr style="margin-bottom: 0px !important; margin-top: 0px !important">
                    <div style="padding: 0.75rem">
                        <button type="submit" class="btn btn-primary">Сохранить</button>
                    </div>
                    <!-- end card-body -->
                </div>
                <!-- end card-->
            </div>
            <!-- end col -->
        </div>
        </b-form>
    </Layout>
</template>
